module.exports = __webpack_public_path__ + "static/img/2829_phase_function_Paper_PointsHejduk_Prediction.c497c59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2829_phase_function_Paper_PointsHejduk_Prediction.png
// module id = i5bi
// module chunks = 0